/*
 * Routes-guard.ts
 * Description: Includes the implementation of
 * the guard function from Vue Router
 */

// Importing Route interface
import {Route} from 'vue-router';
// Importing helper functions
import {checkPermission, checkRole, checkSession} from '@/ts/helpers';

// Implementing beforeEach function from Vue Router to protect the routes
export async function routeGuard(to: Route, from: Route, next: any) {
    // Checking if user session is still valid
    const session = await checkSession();
    // Checking if a page requires authentication
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (session) {
            // Checking if a certain page requires permission to be opened
            if (to.matched.some((record) => record.meta.ManageUsers) && !checkPermission('Manage Users')) {
                next('/');
            }
            if (to.matched.some((record) => record.meta.ManageDonations) && !checkPermission('Manage Donations')) {
                next('/');
            }
            if (to.matched.some((record) => record.meta.CreateProducts) && !checkPermission('Create Products')) {
                next('/');
            }
            if (to.matched.some((record) => record.meta.CreateOrders) && !checkPermission('Create Orders')) {
                next('/');
            }
            if (to.matched.some((record) => record.meta.EditProducts) && !checkPermission('Edit Products')) {
                next('/');
            }
            if (to.matched.some((record) => record.meta.EditRestaurants) && !checkPermission('Edit Restaurants')) {
                next('/');
            }
            if (to.matched.some((record) => record.meta.EditLunchMenus) && !checkPermission('Edit Lunch Menus')) {
                next('/');
            }
            if (to.matched.some((record) => record.meta.ReadStats) && !checkPermission('Read Stats')) {
                next('/');
            }
            if (to.matched.some((record) => record.meta.CreateRestaurants) && !checkPermission('Create Restaurants')) {
                next('/');
            }
            if (to.matched.some((record) => record.meta.DeleteRestaurants) && !checkPermission('Delete Restaurants')) {
                next('/');
            }
            if (to.matched.some((record) => record.meta.ManageStaff) && !checkPermission('Manage Staff')) {
                next('/');
            }
            if (to.matched.some((record) => record.meta.ManageSystem) && !checkPermission('Manage System')) {
                next('/');
            }
            if (to.matched.some((record) => record.meta.ManageOrders) && !checkPermission('Manage Orders')) {
                next('/');
            } else {
                next();
            }
        } else if (to.path !== '/login') {
            next('/login');
        } else {
            next();
        }
    } else if (session) {
        if (checkRole('Administrator')) {
            // If a user is logged in but tries to open an unnecessary page
            // (Register) for example, they will be redirected to dashboard.
            if (to.path !== '/dashboard') {
                next('/dashboard');
            } else {
                next();
            }
        } else if (checkRole('Manager') || checkRole('Staff')) {
            // If a user is logged in but tries to open an unnecessary page
            // (Register) for example, they will be redirected to dashboard.
            if (to.path !== '/orders/manage') {
                next({name: 'orders-manage', params: {id: localStorage.getItem('slug')}});
            } else {
                next();
            }
        } else if (checkRole('Delivery')) {
            if (to.path !== '/orders/delivery') {
                next({name: 'orders-delivery', params: {id: localStorage.getItem('slug')}});
            } else {
                next();
            }
        } else if (checkRole('Social')) {
            if (to.path !== '/donations') {
                next('/donations');
            } else {
                next();
            }
        } else {
            next();
        }
    } else {
        next();
    }
}
